import { Component, Input, Optional } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'sis-required',
	templateUrl: './sis-required.component.html',
	styleUrls: ['./sis-required.component.scss'],
	imports: [TranslateModule],
})
export class SisRequiredComponent {
	@Input()
	public controlName!: string;

	constructor(@Optional() private readonly controlContainer: ControlContainer) {}

	get form(): FormGroup {
		return this.controlContainer.control as FormGroup;
	}

	get control(): FormControl {
		return this.form.get(this.controlName) as FormControl;
	}

	get isRequired(): boolean {
		if (this.control && this.control.validator) {
			const validatorResult = this.control.validator({ value: null } as AbstractControl);
			return validatorResult ? !!validatorResult['required'] : false;
		} else {
			return false;
		}
	}
}
